import axios from 'axios'

export const getSearchParams = (params: any) => {
  const x = axios.create()
  return x.getUri({
    url: '',
    params,
  })
}
